// src/pages/admin/GiftCardsPage.jsx
import { useState } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { adminGiftCardsApi } from '../../api/services'
import { Card, CardHeader, CardBody, Button, StatusBadge, PageSpinner } from '../../components/common/ui'
import toast from 'react-hot-toast'

export default function AdminGiftCardsPage() {
  const qc = useQueryClient()
  const [form, setForm] = useState({ value:1000, validity_days:30, recipient_email:'', quantity:1 })
  const { data, isLoading } = useQuery({ queryKey: ['admin-gift-cards'], queryFn: () => adminGiftCardsApi.index() })
  const issue = useMutation({ mutationFn: () => adminGiftCardsApi.issue(form), onSuccess: () => { toast.success('Gift card(s) issued'); qc.invalidateQueries(['admin-gift-cards']); setForm({ value:1000, validity_days:30, recipient_email:'', quantity:1 }) } })
  const voidCard = useMutation({ mutationFn: id => adminGiftCardsApi.void(id), onSuccess: () => { toast.success('Voided'); qc.invalidateQueries(['admin-gift-cards']) } })

  if (isLoading) return <PageSpinner />
  const { cards = {}, stats = {} } = data?.data?.data || {}
  const list = cards.data || []

  return (
    <div>
      <h1 className="text-xl font-display font-bold mb-6">Gift Cards</h1>
      <div className="grid sm:grid-cols-4 gap-4 mb-6">
        {[['Issued (₹)',`₹${Number(stats.total_issued||0).toLocaleString('en-IN')}`],['Redeemed (₹)',`₹${Number(stats.total_redeemed||0).toLocaleString('en-IN')}`],['Active',stats.active??0],['Expired',stats.expired??0]].map(([l,v])=>(
          <div key={l} className="bg-white border border-border rounded-xl p-4"><p className="text-xs text-muted">{l}</p><p className="text-xl font-bold">{v}</p></div>
        ))}
      </div>
      <Card className="mb-6">
        <CardHeader><span className="font-bold text-sm">Issue Gift Cards</span></CardHeader>
        <CardBody className="flex gap-3 flex-wrap">
          <input className="input" type="number" placeholder="Value ₹" value={form.value} onChange={e => setForm(f => ({ ...f, value: e.target.value }))} />
          <input className="input" type="number" placeholder="Validity days" value={form.validity_days} onChange={e => setForm(f => ({ ...f, validity_days: e.target.value }))} />
          <input className="input" type="email" placeholder="Recipient email (optional)" value={form.recipient_email} onChange={e => setForm(f => ({ ...f, recipient_email: e.target.value }))} />
          <input className="input" type="number" placeholder="Qty" min="1" max="500" value={form.quantity} onChange={e => setForm(f => ({ ...f, quantity: e.target.value }))} />
          <Button loading={issue.isPending} onClick={() => issue.mutate()}>Issue</Button>
        </CardBody>
      </Card>
      <div className="space-y-2">
        {list.map(c => (
          <Card key={c.id}>
            <CardBody className="flex items-center justify-between flex-wrap gap-3">
              <div>
                <div className="flex items-center gap-2"><span className="font-mono font-bold text-sm">{c.code}</span><StatusBadge status={c.status} /></div>
                <p className="text-xs text-muted">₹{Number(c.balance||c.initial_value).toLocaleString('en-IN')} remaining of ₹{Number(c.initial_value).toLocaleString('en-IN')} · {c.recipient_email || 'no recipient'}</p>
              </div>
              {c.status === 'active' && <Button size="sm" variant="danger" loading={voidCard.isPending} onClick={() => voidCard.mutate(c.id)}>Void</Button>}
            </CardBody>
          </Card>
        ))}
        {list.length === 0 && <p className="text-sm text-muted text-center py-8">No gift cards yet.</p>}
      </div>
    </div>
  )
}
